export interface ReaderTranslationRequest {
    nodeId: string;
    fieldName: string;
    targetLanguage: string;
    retryFailed?: boolean;
}

export interface ReaderTranslation extends ReaderTranslationRequest {
    originalText: string;
    translatedText: string | null;
    sourceLanguage: string | null;
    status: string;
}

export const translationRequestKey = (request: ReaderTranslationRequest, originalText: string) =>
    JSON.stringify([request.nodeId, request.fieldName, request.targetLanguage, originalText]);

export const displayedReaderText = (
    originalText: string,
    translation: ReaderTranslation | null,
    showOriginal: boolean,
): string =>
    !showOriginal &&
    translation?.status === 'COMPLETED' &&
    translation.originalText === originalText &&
    translation.translatedText
        ? translation.translatedText
        : originalText;
